import PropTypes from "prop-types";
import { QRCodeSVG } from "qrcode.react";

const WA_LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" rx="9" fill="#25D366"/><path d="M11 28l1.5-5.2c-.9-1.5-1.4-3.2-1.4-5C11.1 12.4 15.4 8 20.8 8s9.7 4.4 9.7 9.8-4.4 9.8-9.7 9.8c-1.7 0-3.3-.4-4.7-1.2L11 28z" fill="#fff"/></svg>`;

const WA_LOGO_DATA_URI = `data:image/svg+xml;base64,${typeof btoa !== "undefined" ? btoa(WA_LOGO_SVG) : ""}`;

/**
 * Renders a scannable WhatsApp multi-device pairing QR from the backend payload.
 */
export function WhatsAppPairingQR({ payload, size = 220 }) {
  if (!payload) return null;
  return (
    <div className="relative" data-testid="whatsapp-pairing-qr">
      <div className="rounded-2xl bg-white p-4 ring-1 ring-slate-200 shadow-sm">
        <QRCodeSVG
          value={payload}
          size={size}
          level="H"
          marginSize={1}
          imageSettings={{
            src: WA_LOGO_DATA_URI,
            height: 30,
            width: 30,
            excavate: true,
          }}
        />
      </div>
      <span className="pointer-events-none absolute -top-1 -left-1 h-4 w-4 border-t-2 border-l-2 border-indigo-500 rounded-tl" />
      <span className="pointer-events-none absolute -top-1 -right-1 h-4 w-4 border-t-2 border-r-2 border-indigo-500 rounded-tr" />
      <span className="pointer-events-none absolute -bottom-1 -left-1 h-4 w-4 border-b-2 border-l-2 border-indigo-500 rounded-bl" />
      <span className="pointer-events-none absolute -bottom-1 -right-1 h-4 w-4 border-b-2 border-r-2 border-indigo-500 rounded-br" />
    </div>
  );
}

WhatsAppPairingQR.propTypes = {
  payload: PropTypes.string,
  size: PropTypes.number,
};

export default WhatsAppPairingQR;
